import axios from "axios";
import { publicClient } from "./client";
import type { LocationSnapshot } from "../types/location";
import { normalizeLocationSnapshot } from "../utils/location";

function getResolveLocationErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as
      | { message?: string | string[]; error?: string }
      | undefined;

    const message = responseData?.message;

    if (Array.isArray(message) && message.length > 0) {
      return message.join(", ");
    }

    if (typeof message === "string" && message.trim()) {
      return message.trim();
    }

    if (typeof responseData?.error === "string" && responseData.error.trim()) {
      return responseData.error.trim();
    }
  }

  return "Could not resolve that postal code.";
}

export async function resolveLocation(postalCode: string, countryCode = "US"): Promise<LocationSnapshot> {
  try {
    const response = await publicClient.get("/locations/resolve", {
      params: { postalCode: String(postalCode || "").trim(), countryCode: String(countryCode || "US").trim().toUpperCase() },
    });
    const location = normalizeLocationSnapshot(response.data);
    if (!location) {
      throw new Error("Could not resolve that postal code.");
    }
    return location;
  } catch (error) {
    throw new Error(getResolveLocationErrorMessage(error));
  }
}
